const displayStringsMap = new Map<string, string>();

displayStringsMap.set("incontact_web_subscribe", "Web Subscribe");
displayStringsMap.set("incontact_web_admin", "Web Admin");
displayStringsMap.set("incontact_event_registration", "Event");

export default displayStringsMap;
